import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PressReleaseArticleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(-65.000000, -46.000000)"
      >
        <g transform="translate(65.000000, 46.000000)">
          <path
            d="M-0.0001,15 C-0.0001,23.284 6.7159,30 14.9999,30 C23.2839,30 29.9999,23.284 29.9999,15 C29.9999,6.715 23.2839,0 14.9999,0 C6.7159,0 -0.0001,6.715 -0.0001,15"
            fill="#8C2A8E"
          />
          <path
            d="M20.3519,16.29 C20.3519,19.443 17.7959,22 14.6429,22 C11.4889,22 8.9329,19.443 8.9329,16.29"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.6425,20.1005 C12.4505,20.1005 10.6745,18.3235 10.6745,16.1315 L10.6745,9.9685 C10.6745,7.7765 12.4505,5.9995 14.6425,5.9995 C16.8345,5.9995 18.6115,7.7765 18.6115,9.9685 L18.6115,16.1315 C18.6115,18.3235 16.8345,20.1005 14.6425,20.1005"
            fill="#ffffff"
            className={styles.white}
          />
          <line
            stroke="#8C2A8E"
            strokeLinecap="round"
            strokeWidth="0.975"
            x1="14.6415"
            x2="18.6115"
            y1="10.5361"
            y2="10.5361"
          />
          <line
            stroke="#8C2A8E"
            strokeLinecap="round"
            strokeWidth="0.975"
            x1="14.6415"
            x2="18.6115"
            y1="12.8833"
            y2="12.8833"
          />
          <line
            stroke="#8C2A8E"
            strokeLinecap="round"
            strokeWidth="0.975"
            x1="14.6415"
            x2="18.6115"
            y1="15.1909"
            y2="15.1909"
          />
          <line
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            x1="14.4999"
            x2="14.4999"
            y1="23.5"
            y2="19"
          />
        </g>
      </g>
    </Icon>
  )
}
